import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { JobService } from 'src/app/_services/job.service';

@Component({
    selector: 'app-job',
    templateUrl: './job.component.html',
    styleUrls: ['./job.component.css'],
    standalone: false
})
export class JobComponent implements OnInit {

  jobForm: UntypedFormGroup;
  types = ['Full Time', 'Part time', 'Internship', 'Consultant', 'Freelance', 'Volunteer'];
  submitting = false;

  constructor(private jobService: JobService, private toastService: ToastrService,
    private router: Router, private fb: UntypedFormBuilder) {
      this.jobForm = this.fb.group({
        'title': new UntypedFormControl('', Validators.required),
        'description': new UntypedFormControl('', Validators.required),
        'location': new UntypedFormControl('', Validators.required),
        'type': new UntypedFormControl('', Validators.required),
        'status': new UntypedFormControl(true, Validators.required),
      });
  }

  ngOnInit(): void {}

  submit() {
    this.submitting = true;
    this.jobService.addJob(this.jobForm.value).subscribe(
      (response: any) => {
        this.toastService.success(response.message);
        this.router.navigateByUrl('/admin/jobs');
      },
      (error) => {
        this.toastService.error(error);
        this.submitting = false;
      },
    );
  }
}